import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import TrustSection from '../components/TrustSection'
import ProblemSection from '../components/ProblemSection'
import PlatformArchitectureSection from '../components/PlatformArchitectureSection'
import SolutionSection from '../components/SolutionSection'
import PlatformSection from '../components/PlatformSection'
import TestimonialsSection from '../components/TestimonialsSection'
import IndustriesSection from '../components/IndustriesSection'
import CaseStudiesSection from '../components/CaseStudiesSection'
import ROICalculator from '../components/ROICalculator'
import SecuritySection from '../components/SecuritySection'
import AboutSection from '../components/AboutSection'
import PilotSection from '../components/PilotSection'
import GetStartedSection from '../components/GetStartedSection'
import CTASection from '../components/CTASection'
import Footer from '../components/Footer'

export default function HomePage() {
  const location = useLocation()

  useEffect(() => {
    if (!location.hash) {
      return
    }

    const targetId = location.hash.slice(1)
    const frame = window.requestAnimationFrame(() => {
      const element = document.getElementById(targetId)
      if (!element) {
        return
      }

      const offset = 72
      window.scrollTo({
        top: element.getBoundingClientRect().top + window.scrollY - offset,
        behavior: 'smooth',
      })
    })

    return () => window.cancelAnimationFrame(frame)
  }, [location.hash])

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustSection />
        <ProblemSection />
        <PlatformArchitectureSection />
        <SolutionSection />
        <PlatformSection />
        <TestimonialsSection />
        <IndustriesSection />
        <CaseStudiesSection />
        <ROICalculator />
        <SecuritySection />
        <AboutSection />
        <PilotSection />
        <GetStartedSection />
        <CTASection />
      </main>
      <Footer />
    </>
  )
}
